import React, { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  Typography,
  TextField,
  InputAdornment,
  Stack,
  Card,
  Avatar,
  Divider,
} from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';

import { request } from '../../../Utils/request';
import { useSelector } from 'react-redux';

interface BookingsTabProps {
  onTripClick: (trip: any) => void;
}

const BookingsTab: React.FC<BookingsTabProps> = ({ onTripClick }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [trips, setTrips] = useState<any[]>([]);
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);

  useEffect(() => {
    const fetchTrips = async () => {
      const res = await request<{ data:any }>('/bookings/trips/created?filter=upcoming&page=1&limit=10', {
        method: 'GET',
        authorization: true,
      });
      setTrips(res?.data);
    }
    if(isLoggedIn)
    fetchTrips();
  }, []);
  
  if(trips.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          No Bookings found
        </Typography>
      </Box>
    )
  }

  return (
    <>
      <TextField
        fullWidth
        type="date"
        label="Select Date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        sx={{ mb: 3 }}
        InputLabelProps={{ shrink: true }}
      />

      <Stack spacing={2}>
        {trips.map((trip) => (
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 1,
                  mb: 2,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  '&:hover': {
                    boxShadow: 2,
                  },
                }}
                  onClick={() => onTripClick(trip)}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                  <Avatar
                    src={trip.files?.[0]?.fileURL}
                    sx={{ width: 60, height: 60, borderRadius: 2, mr: 2 }}
                    variant="rounded"
                  />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
                      {trip.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Location: {typeof trip.location === 'object' ? trip.location?.name : trip.location}
                    </Typography>
                  </Box>
                  <Divider orientation="vertical" flexItem sx={{ height: '100%',width: '1px', backgroundColor: 'red' }} />
                  <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                    <Typography variant="h4" fontWeight="bold" color="#008387">
                      {trip.totalUpcomingBookings || 0}
                    </Typography>
                    <Typography sx={{ fontSize: '12px',color:'#008387', fontWeight: 500 }}>
                      Bookings
                    </Typography>
                  </Box>
                </Box>
              </Card>
        ))}
      </Stack>
    </>
  );
};

export default BookingsTab;
